const popoverRowClasses = "flex items-center";

const popoverKeyClasses =
    "text-subtle text-sm leading-[calc(var(--spacing)*5.5)]";

const popoverValueClasses =
    "text-sm leading-[calc(var(--spacing)*5.5)]";

const PopoverInfoRow = ({
    label,
    value,
    bold = false,
    rightContent = null,
}) => {
    return (
        <div className={popoverRowClasses}>
            <span className={popoverKeyClasses}>{label}:&nbsp;</span>

            <span className={popoverValueClasses}>
                {bold ? <b>{value}&nbsp;</b> : value}
            </span>
            {rightContent}
        </div>
    );
};

export default PopoverInfoRow;